import { render, staticRenderFns } from "./StoreVisits.vue?vue&type=template&id=73513748&scoped=true&"
import script from "./StoreVisits.vue?vue&type=script&lang=ts&"
export * from "./StoreVisits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73513748",
  null
  
)

export default component.exports